

export const CustomLabelsLayer = ({ bars, data, vertical }) => {
  if (!data.some(d => d.customLabel)) return null;

  return bars.map(bar => {
    const { data, x, y, width, height } = bar;
    if (!data.customLabel) return null;

    const yOffset = vertical ? -10 : height / 2;
    const xOffset = vertical ? width / 2 : 10;

    return (
      <text
        key={`${bar.key}-label`}
        x={x + xOffset}
        y={y + yOffset}
        textAnchor="middle"
        dominantBaseline="middle"
        style={{ fill: 'white', fontSize: 10 }}
      >
        {data.customLabel}
      </text>
    );
  });
};